<template lang="pug">
.row-carousel(:class="{ 'row-carousel-new-style': newStyle }")
    .notice-container(:class="`notice-container-${currentIndex}`")
        .go-horse(
            v-if="list.length>0"
            ref="box"
            :style="styles"
        )
            .border-bkg(
                v-for="(item, index) in list"
                :key="index"
                ref="item"
                :class="`border-bkg-${item.styleType}`"
            )
                .go-horse-block
                    img.go-hores-img(
                        v-if="item.leadIcon && !newStyle"
                        :src="item.leadIcon"
                    )
                    .go-hores-info
                        .info-prefix {{ item.leadPrefix || '' }}
                        .info-suffix {{ item.leadSuffix || '' }}
</template>

<script>
const regNumber = /^\d+$/;
export default {
  name: 'Carousel',
  props: {
    autoplay: {
      validator(val) {
        return regNumber.test(val);
      },
      default: 3000,
    },
    speed: {
      validator(val) {
        return regNumber.test(val);
      },
      default: 500,
    },
    dataList: {
      type: Array,
      default: () => ([]),
    },
    newStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentIndex: 1,
      indexMq: 0,
      timer: null,

      styles: {
        top: 0,
        transitionDuration: 0,
      },
      list: this.dataList,
      defaultImg: 'https://m.hellobike.com/resource/gallery/350/G42GNIwJ_Vector.png',
    };
  },
  computed: {
    lenMq() {
      return this.list ? this.list.length : 0;
    },
    height() {
      if (this.$refs.item) {
        const { height } = this.$refs.item[0].getBoundingClientRect() || {};
        return height;
      }
      return 0;
    },
  },
  watch: {
    dataList(newValue) {
      this.list = newValue;
      this.currentIndex = this.list[0].styleType;
      this.setMarquee();
    },
  },
  mounted() {

  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    this.indexMq = 0;
  },
  methods: {
    setMarquee() {
      if (this.list.length > 1) {
        this.timer = setInterval(() => {
        // eslint-disable-next-line no-plusplus
          this.currentIndex = this.list[this.indexMq].styleType;
          this.setTop(this.speed, -(++this.indexMq * this.height));
          if (this.indexMq >= this.lenMq) {
            this.currentIndex = this.list[0].styleType;
            // 若当前是新1(最後一個)，
            const template = this.list;
            this.list = this.list.concat(template);
            setTimeout(() => {
              this.list.splice(0, template.length);
              // 瞬间回到老1（第一个）
              this.indexMq = 0;
              this.setTop(0, 0);
            }, this.speed);
          }
        }, this.autoplay);
      }
    },
    setTop(speed, top) {
      this.styles.transitionDuration = `${speed}ms`;
      this.styles.top = `${top}px`;
    },
  },
};
</script>

<style lang="less" scoped>
.row-carousel {
  width: 100%;

  .notice-container {
    width: 100%;
    height: 0.38rem;
    flex-shrink: 0;
    background: linear-gradient(90deg, #fff 0%, #f1f1f1 100%);
    backdrop-filter: blur(4px);
    overflow: hidden;
    position: relative;
    color: black;

    &.notice-container-2 {
      background: linear-gradient(90deg, #fffbef 0%, #fff4d7 100%);
    }

    &.notice-container-3 {
      background: linear-gradient(90deg, #fff3f3 0%, #ffe9e9 100%);
    }

    .go-horse {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;

      .border-bkg {
        display: flex;
        width: 100%;
        justify-content: center;

        .go-horse-block {
          display: flex;
          height: 0.38rem;
          justify-content: center;
          align-items: center;
          width: 100%;

          .go-hores-img {
            min-width: 0.12rem;
            height: 0.15rem;
            margin-bottom: 0.02rem;
          }

          .go-hores-info {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 0.06rem;
            color: #7c7c7c;
            font-family: 'PingFang SC', sans-serif;
            font-weight: 500;
            font-size: 0.12rem;
            display: flex;

            .info-suffix {
              color: #fb990f;
            }
          }
        }

        &.border-bkg-2 {
          .go-horse-block {
            .go-hores-img {
              min-width: 0.2rem;
              height: 0.17rem;
              margin-bottom: 0.02rem;
            }

            .go-hores-info {
              margin-left: 0.03rem;

              .info-suffix {
                color: #fa4614;
              }
            }
          }
        }

        &.border-bkg-3 {
          .go-horse-block {
            .go-hores-img {
              min-width: 0.2rem;
              height: 0.17rem;
              margin-bottom: 0.02rem;
            }

            .go-hores-info {
              margin-left: 0.03rem;

              .info-suffix {
                color: #fa4614;
              }
            }
          }
        }
      }
    }
  }
}

.row-carousel-new-style {
  .notice-container {
    background: none !important;
    backdrop-filter: none;
  }

  .go-hores-info {
    font-weight: 400 !important;
    color: #6b0d00 !important;

    .info-suffix {
      font-weight: 500;
    }
  }

  .go-horse-block {
    justify-content: flex-start !important;
  }
}
</style>
